import { TABLE_PARAMETERS, resolveTableParams } from './resolveTableParams'

export const hierarchicalTableVariants = {
  default: {
    code: 'default',
    displayName: 'Default',
    description: 'Standard hierarchical table with depth-banded rows and expandable tree structure.',
    parameters: TABLE_PARAMETERS,
    resolve: (params) => resolveTableParams(params)
  },
  flat: {
    code: 'flat',
    displayName: 'Flat',
    description: 'Clean hierarchy with minimal borders. Depth levels use subtle background shading only.',
    parameters: TABLE_PARAMETERS,
    resolve: (params) => resolveTableParams(params)
  },
  glass: {
    code: 'glass',
    displayName: 'Glass',
    description: 'Translucent frosted-glass hierarchy with rounded corners. Works best on colored backgrounds.',
    parameters: TABLE_PARAMETERS,
    resolve: (params) => resolveTableParams(params)
  },
  legacy: {
    code: 'legacy',
    displayName: 'Legacy',
    description: 'Classic hierarchy with full cell borders and darker depth progression.',
    parameters: TABLE_PARAMETERS,
    resolve: (params) => resolveTableParams(params)
  }
}
